import appConfig from "configs/app.config";
import * as Yup from "yup";

const APP_MODE = appConfig.APP_MODE;
const Domains = appConfig.DOMAIN;
const restrictedDomains = Domains.split(",").map((domain) => domain.trim().toLowerCase());
export const emailValidation = Yup.string()
  .matches(
    /^(?!\.)[^\s@]+@[^\s@]+\.[^\s@]+(?<!\.)$/,
    "Please enter a valid email"
  )
  .test("restricted-domains", "This email domain is not allowed", (value) => {
    if (APP_MODE === "Production" && value) {
      const domain = value.split("@")[1]; // Extract domain
      return !restrictedDomains.includes(domain.toLowerCase());
    }
    return true;
  });


export const checkValidNumber = (value) =>{
    return value && !isNaN(parseInt(value)) ? parseInt(value) :  10
}

export const createValidationSchema = (fieldName) => {
  return Yup.string()
    .test('is-number', `${fieldName} must be a number`, (value) => {
      if (!value) return true;
      return !isNaN(value);
    })
    .test('decimal-places', `Only up to 4 decimal places allowed for ${fieldName}`, (value) => {
      if (!value) return true;
      const decimalPart = value?.split('.')[1];
      return !decimalPart || decimalPart?.length <= 4;
    })
};

export const scrolltoTop = () => {
  window.scrollTo(0, 0, { behavior: "smooth" });
};

export const IsEmptyFieldValidate = (fieldName) => {
  return Yup.string()
    .transform(value => (value ? value.trim() : ''))       
    .test(
      'not-only-spaces',
      `Please enter a valid ${fieldName}`,
      value => value !== ''
    )  
};

export const rowPerPage = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export const buildSelectedRecordTypes = (recordTypes, orderDraftId) => {
  return recordTypes
    ?.filter((type) => type?.selected)
    ?.map((type) => {
      return {
        id: type.value,
        value: type.value,
        name: type.name || type.label || "",
        description: type.description ?? null,
        flowType: type.flowType || null,
        selected: true,
        referenceNumber: null,
        dataRange: 1,
        fromDate: null,
        toDate: null,
        presentDate: false,
        document: null,
        orderId: orderDraftId || null,
      };
    });
};

export const normalizeRecordTypeId = (value) => {
  if (value == null) return null;
  if (Array.isArray(value)) {
    const first = value.find((item) => item != null);
    return normalizeRecordTypeId(first);
  }
  if (typeof value === "object") {
    return normalizeRecordTypeId(
      value.id ?? value.value ?? value.recordId ?? value.recordTypeId
    );
  }
  const id = Number(value);
  return Number.isNaN(id) ? null : id;
};
